import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { cn } from "@/lib/cn";
/** Инициалы из ФИО: «Пётр Попов» → «ПП», один токен → первые 2 буквы. */
function initials(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return "?";
    if (parts.length === 1)
        return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
const SIZES = {
    sm: "h-8 w-8 text-xs",
    md: "h-12 w-12 text-sm",
    lg: "h-24 w-24 text-2xl",
};
/**
 * Кружок с фото профиля; при отсутствии/ошибке загрузки — инициалы на
 * амбер-акценте. Сброс ошибки при смене `src` (после загрузки нового фото
 * URL меняется через ?v=, и <img> повторяет попытку).
 */
export function Avatar({ src, name, size = "md", className }) {
    const [failed, setFailed] = useState(false);
    useEffect(() => setFailed(false), [src]);
    const showImg = Boolean(src) && !failed;
    return (_jsx("span", { className: cn("inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full bg-secondary font-semibold", SIZES[size], className), children: showImg ? (_jsx("img", { src: src, alt: name, className: "h-full w-full object-cover", onError: () => setFailed(true) })) : (_jsx("span", { className: "text-[color:var(--sg-amber)]", children: initials(name) })) }));
}
